var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AskErrorMessage, CreateModelFromBlueprintMessage, ResponseCreateModelFromBlueprint } from "flavr-common";
import { Module } from "@modules/module";
import { modelPool, determineModelNameForPrinting, getModelNameByUID } from "@modules/model";
import { blueprintLoadingService } from "./BlueprintLoadingService";
/**
 * Creates runtime model hierarchies from blueprint assets so higher-level tools can spawn complex content through a single request.
 *
 * Messages:
 * - `CreateModelFromBlueprintMessage` - Identifies the blueprint asset and target parent model and is used to create the corresponding runtime hierarchy.
 */
export class BlueprintModule extends Module {
    /**
     * Subscribes to `CreateModelFromBlueprintMessage` both as an ask request (local case, answers with the created
     * models or an error) and as a plain broadcast (remote case, applies the blueprint without answering).
     */
    constructor() {
        super("BlueprintModule");
        this.handleCreateModelFromBlueprintMessageRemote = (msg) => __awaiter(this, void 0, void 0, function* () {
            const parentModel = modelPool.getModel(msg.parentUid);
            if (parentModel === undefined) {
                console.warn(`[blueprint] Cannot create blueprint because the parent model ${determineModelNameForPrinting(msg.parentUid)} doesn't exist`);
                return;
            }
            const newModels = yield blueprintLoadingService.parseFile(msg.fileId, parentModel, false);
            if (newModels === undefined)
                return;
            modelPool.flushMessages();
        });
        this.handleCreateModelFromBlueprintMessage = (msg, askId) => __awaiter(this, void 0, void 0, function* () {
            const parentModel = modelPool.getModel(msg.parentUid);
            if (parentModel === undefined) {
                if (askId !== undefined) {
                    this.connection.answer(askId, new AskErrorMessage(`BlueprintModule can't find parent model  ${getModelNameByUID(msg.parentUid)}`));
                }
                return;
            }
            const blueprintModels = yield blueprintLoadingService.parseFile(msg.fileId, parentModel);
            if (blueprintModels === undefined) {
                if (askId !== undefined) {
                    this.connection.answer(askId, new AskErrorMessage(`BlueprintModule Can't parse blueprint ${msg.fileId}`));
                }
                return;
            }
            modelPool.flushMessages();
            if (askId !== undefined) {
                this.connection.answer(askId, new ResponseCreateModelFromBlueprint(blueprintModels.map((model) => model.getUID())));
            }
        });
        // local case
        this.connection.subscribeByTypeOrAskRequest(CreateModelFromBlueprintMessage, this.handleCreateModelFromBlueprintMessage);
        // remote case
        this.connection.subscribeByType(CreateModelFromBlueprintMessage, this.handleCreateModelFromBlueprintMessageRemote);
    }
    /**
     * Keeps the standard module life-cycle entry point even though blueprint subscriptions are already registered in the constructor.
     */
    init() { }
}
